import * as React from 'react';
import { useEffect, useState } from 'react';
import { AutoComplete } from 'antd';
import { debounce } from 'lodash';
import { CompanySearchResponse } from 'components/context/types';
import { DataSourceItemType } from 'antd/lib/auto-complete';
import t from 'utils/translations';
import { apiSearchCompanies } from 'api';

interface Props {
    setSearchResult?: (result: any) => void;
    nullify?: boolean; // Special solution for special people. Value of this prop makes no difference, only toggling of
    // value makes the search field empty
}
export default function CompareInput(props: Props) {
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState<DataSourceItemType[]>(
        []
    );

    useEffect(() => {
        setSearchTerm('');
    }, [props.nullify]);

    const onSearch = (word: string) => setSearchTerm(word);

    const onSelect = (value: string) => {
        const valueObj = JSON.parse(value);
        setSearchTerm(valueObj.name);
        props.setSearchResult &&
            props.setSearchResult({
                businessId: valueObj.businessId,
                name: valueObj.name,
                statementDate: valueObj.statementDate
            });
    };

    const onChange = debounce(
        (word: string) => {
            setLoading(true);
            if (word.length >= 3) {
                sendSearchRequest(word)
                    .then((response: Response) => response.json())
                    .then((data: CompanySearchResponse) => {
                        const dataSource = data.content.map(datum => ({
                            text: `${datum.name} | ${datum.businessId}`,
                            value: JSON.stringify({
                                businessId: datum.businessId,
                                name: datum.name,
                                statementDate: datum.statementDate
                            })
                        }));
                        setSearchResults(dataSource);
                    })
                    .catch(() => setSearchResults([]))
                    .finally(() => setLoading(false));
            } else {
                setSearchResults([]);
            }
        },
        500,
        { maxWait: 1000, leading: true }
    );

    const sendSearchRequest = (value: string): Promise<Response> => {
        try {
            const searchObject = JSON.parse(value);
            // TODO: make try-catch thing better/remove it. Now it is used because
            // the type of value is different for onSelect and onChange events.
            // However, it caused a bug because when trying to input a businessId,
            // ie, a number, the JSON.parse succeeds and a null value is sent as
            // a search string. The below "if" patches this bug.
            if (typeof searchObject === 'number') {
                return apiSearchCompanies(value);
            }
            return apiSearchCompanies(searchObject.businessId);
        } catch (e) {
            return apiSearchCompanies(value);
        }
    };

    return (
        <>
            <AutoComplete
                autoFocus={true}
                backfill={true}
                dataSource={searchResults}
                defaultActiveFirstOption={false}
                onChange={onChange}
                onSearch={onSearch}
                onSelect={onSelect}
                placeholder={t('SEARCH_BY_NAME_OR_BUSINESS_ID')}
                value={searchTerm}
                style={{ width: '100%' }}
            />
        </>
    );
}
